import axios from './axios';

import auth from '../resources/Auth';

export default {
  all: async () => {
    let url = `${process.env.REACT_APP_API_URL}/reservations`;
    let token = localStorage.getItem('auth');

    return await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  findOne: async (body) => {
    const url = `${process.env.REACT_APP_API_URL}/reservations/findOne`;

    return await axios.post(
      url,
      { ...body },
      {
        headers: { Authorization: `Bearer ${auth.token}` },
      }
    );
  },

  availableDate: async (body) => {
    const url = `${process.env.REACT_APP_API_URL}/reservations/availableDate`;

    return await axios.post(
      url,
      { ...body },
      {
        headers: { Authorization: `Bearer ${auth.token}` },
      }
    );
  },

  fetchTime: async (id, date) => {
    let url = `${process.env.REACT_APP_API_URL}/reservations/fetchTime/${id}/${date}`;
    let token = localStorage.getItem('auth');

    return await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  saveReservation: async (body) => {
    let url = `${process.env.REACT_APP_API_URL}/reservations/store/${body.service_id}`;
    let token = localStorage.getItem('auth');

    return await axios.post(
      url,
      { ...body },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  },

  remove: async (id) => {
    let url = `${process.env.REACT_APP_API_URL}/reservations/remove/${id}`;
    let token = localStorage.getItem('auth');

    return await axios.delete(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  // Dati per la schermata di pagamento dell'acconto
  paymentShow: async (reservationId) => {
    const url = `${process.env.REACT_APP_API_URL}/reservations/${reservationId}/payment`;

    return await axios.get(url, {
      headers: { Authorization: `Bearer ${auth.token}` },
    });
  },

  // Crea (o riusa) l'ordine PayPal: restituisce approve_url, amount ed expires_at
  paymentCreate: async (reservationId) => {
    const url = `${process.env.REACT_APP_API_URL}/reservations/${reservationId}/payment`;

    return await axios.post(
      url,
      {},
      {
        headers: { Authorization: `Bearer ${auth.token}` },
      }
    );
  },

  // Cattura il pagamento dopo l'approvazione su PayPal
  paymentCapture: async (paypalOrderId) => {
    const url = `${process.env.REACT_APP_API_URL}/reservations/payment/${paypalOrderId}/capture`;

    return await axios.post(
      url,
      {},
      {
        headers: { Authorization: `Bearer ${auth.token}` },
      }
    );
  },
};
